import React, { useEffect, useRef } from "react";
import { View } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import LottieView from "./sharedComponents/LottieView";

type Props = {
  active: boolean;
};

const LottieConfetti: React.FC<Props> = ({ active }) => {
  const confettiRef = useRef<any>(null);

  useEffect(() => {
    if (active && confettiRef.current) {
      // Reset and play animation
      confettiRef.current.reset();
      confettiRef.current.play();
    }
  }, [active]);

  if (!active) return null;

  return (
    <View style={styles.container} pointerEvents="none">
      <LottieView
        ref={confettiRef}
        source={require("@/assets/animations/confetti.json")}
        style={styles.lottie}
        autoPlay={false}
        loop={false}
        speed={1}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
  },
  lottie: {
    flex: 1,
  },
});

export default LottieConfetti;
